// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__eZmO1","btnBanner":"styles_btnBanner__ePu9j","disabled":"styles_disabled__9gj3U"};